/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CompanyDeptVo from './CompanyDeptVo';
import CourseVo from './CourseVo';




  /**
   * The CourseStandardVo model module.
   * @module course_standard/model/CourseStandardVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>CourseStandardVo</code>.
   * @alias module:course_standard/model/CourseStandardVo
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>CourseStandardVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/CourseStandardVo} obj Optional instance to populate.
   * @return {module:course_standard/model/CourseStandardVo} The populated <code>CourseStandardVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'targetId')) {
        obj['targetId'] = ApiClient.convertToType(data['targetId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'version')) {
        obj['version'] = ApiClient.convertToType(data['version'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'awarded')) {
        obj['awarded'] = ApiClient.convertToType(data['awarded'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'course')) {
        obj['course'] = CourseVo.constructFromObject(data['course']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'companyDeptList')) {
        obj['companyDeptList'] = ApiClient.convertToType(data['companyDeptList'], [CompanyDeptVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 课程目标id
   * @member {Integer} targetId
   */
  exports.prototype['targetId'] = undefined;
  /**
   * 名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 摘要
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 版本
   * @member {String} version
   */
  exports.prototype['version'] = undefined;
  /**
   * 编号
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * 状态 0删除 1未发布，2发布
   * @member {Integer} status
   */
  exports.prototype['status'] = undefined;
  /**
   * 1精品课程
   * @member {Integer} awarded
   */
  exports.prototype['awarded'] = undefined;
  /**
   * 关联课程
   * @member {module:course_standard/model/CourseVo} course
   */
  exports.prototype['course'] = undefined;
  /**
   * 创建课程标准的学校-分院
   * @member {Array.<module:course_standard/model/CompanyDeptVo>} companyDeptList
   */
  exports.prototype['companyDeptList'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 修改时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;



  export default exports;
;


